// extracted by css-extract-rspack-plugin
export default {"badge":"badge-BikFMf","free":"free-NCYgiv","student":"student-ESphNj","member":"member-cwdxaI","advanced":"advanced-A0cmi8"};